// extracted by mini-css-extract-plugin
export default {"modernButtonContainer":"ExpandModernButton_modernButtonContainer__Pf6o-"};